module.exports = __webpack_public_path__ + "img/daily-tournament-bg_960.4724d649.png";